module.exports = __webpack_public_path__ + "static/media/cybercrime@2x.f3fb69c4.png";